var reliefCodeSearch = angular.module('taric.relief.search', ['taric.model.menu', 'common.helper', 'taric.model.relief'])
    .controller('ReliefCodeController', function (CONSTANTS, ReliefReportModel, $rootScope, $scope, CommonHelper, reliefCodeTypes, $timeout, $state, $stateParams, $filter, $translate, $location) {
        var reliefCodeCtrl = this;
        reliefCodeCtrl.init = function(){
            reliefCodeCtrl.dateFormat = CONSTANTS.dateFormat;
            reliefCodeCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            reliefCodeCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            reliefCodeCtrl.searchCriteria = ReliefReportModel.getSearchCriteria();
            reliefCodeCtrl.searchResult = ReliefReportModel.getSearchResult();
            reliefCodeCtrl.reliefCodeTypes = reliefCodeTypes;

            if (reliefCodeCtrl.isExternalLink() && reliefCodeCtrl.validateExternalParameters()) {
                // get valid reliefCodeType
                reliefCodeCtrl.searchCriteria.reliefCodeType = CommonHelper.getValidSelectedItem(
                    reliefCodeTypes,
                    reliefCodeCtrl.searchCriteria.reliefCodeType,
                    null);

                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                reliefCodeCtrl.loadDataFromServer(1);
            }
        };

        reliefCodeCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after viewing relief detail.
            return (!$stateParams.frm || $stateParams.frm !== 'taric.report.relief.view') && $stateParams.sd;
        };

        // Check whether the external parameters are valid or not
        reliefCodeCtrl.validateExternalParameters = function(){
            reliefCodeCtrl.resetError();
            return reliefCodeCtrl.validateSimulationDate();
        };

        reliefCodeCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                reliefCodeCtrl.errorCode = CommonHelper.validateSimulationDate(reliefCodeCtrl.searchCriteria.simulationDate);
                if (reliefCodeCtrl.errorCode) {
                    reliefCodeCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return reliefCodeCtrl.errorCode === null;
        };

        reliefCodeCtrl.search = function(){
            reliefCodeCtrl.loadDataFromServer(1);
        };

        reliefCodeCtrl.onDateChange = function(dateString){
            reliefCodeCtrl.resetError();
            reliefCodeCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(reliefCodeCtrl.searchCriteria.simulationDate, dateString);
            if (reliefCodeCtrl.searchCriteria.simulationDate){
                 ReliefReportModel.loadReliefCodeTypes(reliefCodeCtrl.searchCriteria.simulationDate).then(function(reliefCodeTypes){
                     reliefCodeCtrl.reliefCodeTypes = reliefCodeTypes;
                 }, function(error){
                     reliefCodeCtrl.errorCode = error.data.code;
                     reliefCodeCtrl.errorParams = error.data.params;
                 });
            }
        };

        reliefCodeCtrl.resetError = function(){
            reliefCodeCtrl.errorCode = null;
            reliefCodeCtrl.errorParams = null;
        };

        reliefCodeCtrl.openDatePicker = function(){
            reliefCodeCtrl.isDatePickerOpen = true;
        };

        reliefCodeCtrl.resetSearchResult = function(){
            reliefCodeCtrl.searchResult = null;
            ReliefReportModel.resetSearchResult();
        };

        reliefCodeCtrl.searchResultPageChanged = function(page){
            reliefCodeCtrl.loadDataFromServer(page);
        };

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            reliefCodeCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                reliefCodeCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        reliefCodeCtrl.loadDataFromServer = function(page){

            // Reset search result before searching
            reliefCodeCtrl.resetSearchResult();
            reliefCodeCtrl.errorCode = null;
            reliefCodeCtrl.errorParams = null;
            reliefCodeCtrl.searching = true;
            ReliefReportModel.searchReliefCodes(page).then(function(searchResult) {
                reliefCodeCtrl.searchResult = searchResult;
                reliefCodeCtrl.searching = false;
                reliefCodeCtrl.searchResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(reliefCodeCtrl.searchCriteria.simulationDate);
                if (reliefCodeCtrl.searchResult.infoCode &&
                    "i8n.common.pastDate" === reliefCodeCtrl.searchResult.infoCode) {
                    reliefCodeCtrl.searchResult.infoParams = CONSTANTS.pastDate;
                }
                reliefCodeCtrl.updateBrowserURL();
            }, function(error){
                reliefCodeCtrl.errorCode = error.data.code;
                reliefCodeCtrl.errorParams = error.data.params;
                reliefCodeCtrl.searching = false;
            });
        };

        /**
         * Print relief code
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/reliefcode/search?sd={SimulationDate}&rt={ReliefCodeType}&rc={ReliefCode}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/report/reliefcode/search?sd=2015-01-01&rt=E&rc=01&l=en
         */
        reliefCodeCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep parameter 'frm' because there is no return to caller page
            $location.search({
                sd: CommonHelper.getBookmarkDateString(reliefCodeCtrl.searchCriteria.simulationDate),
                rt: CommonHelper.removeSpaceCharacters(reliefCodeCtrl.searchCriteria.reliefCodeType),
                rc: CommonHelper.removeSpaceCharacters(reliefCodeCtrl.searchCriteria.reliefCode),
                l : $translate.use()
            }).replace();
        };

        //View relief detail
        reliefCodeCtrl.viewDetail = function (item){
            $state.go('taric.report.relief.view', {cd: item.reliefCode, sd: CommonHelper.getBookmarkDateString(reliefCodeCtrl.searchCriteria.simulationDate)});
        };

        // export pdf
        reliefCodeCtrl.print = function(options){
            if (!reliefCodeCtrl.searchCriteria.simulationDate){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningPrint');
            ReliefReportModel.searchReliefCodes().then(function(searchResult) {

                reliefCodeCtrl.allSearchResult = searchResult;
                setTimeout(function(){
                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(reliefCodeCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.report.reliefCode.search.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);
            }, function(error){
                reliefCodeCtrl.errorCode = error.data.code;
                reliefCodeCtrl.errorParams = error.data.params;
                $rootScope.$broadcast('stopSpinningPrint');
            });
        };

        $scope.$on('printDocument', function(event, data) {

            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, reliefCodeCtrl.print, true);
        });

    });



// WEBPACK FOOTER //
// ./app/taric/report/relief/search/relief-code-search.js